import { create } from 'zustand';

import { DialogMessage } from '@/api/messaging/types.ts';

type LastEvents = {
  lastMessage?: DialogMessage;
  newPair?: any;
  userVerified?: boolean;
  photoStateChange?: { photo_hid: string };
  videoStateChange?: { video_hid: string };
};

interface WebSocketStore {
  lastEvents: LastEvents;
  setLastEvents: (events: Partial<LastEvents>) => void;
}

export const useWebSocketStore = create<WebSocketStore>((set) => ({
  lastEvents: {
    lastMessage: undefined,
    newPair: undefined,
    userVerified: undefined,
    photoStateChange: undefined
  },
  setLastEvents: (events) => set({ lastEvents: { ...events } })
}));
